import Component from "@glimmer/component";
import CustomFieldCombobox from "./combobox";
import CustomFieldConfirm from "./confirm";
import CustomFieldMultiselect from "./multi-select";
import CustomFieldText from "./text";

const COMPONENTS = {
  confirm: CustomFieldConfirm,
  dropdown: CustomFieldCombobox,
  multiselect: CustomFieldMultiselect,
  text: CustomFieldText,
};

export default class FormFieldCustom extends Component {
  get component() {
    return COMPONENTS[this.args.filter.type] || COMPONENTS.text;
  }

  <template>
    <this.component
      class="circles-search-filter__custom"
      ...attributes
      @controller={{@controller}}
      @filter={{@filter}}
      @placeholder={{@placeholder}}
      @value={{@value}}
    />
  </template>
}
